import productosRenderer from "./renderers/productos.js";
import { precioRenderer, impuestoRenderer, ventaRenderer } from "./renderers/dinero";
import { facturaRenderer } from "./renderers/factura.js";
import { publicHaspRenderer } from "./renderers/mexico.js";
import { estadoRenderer } from "./renderers/estado";


const columns = (vm) => [
    { data: "fecha" },
    { data: null, render: facturaRenderer(vm) },
    { data: "tercero_nit", class: "text-right" },
    { data: "tercero_nombre" },
    { render: productosRenderer(vm) },
    { class: "text-right", render: precioRenderer(vm) },
    { class: "text-right", render: impuestoRenderer(vm) },
    { class: "text-right", render: ventaRenderer(vm) },
    { class: "text-right", render: publicHaspRenderer(vm), },
    { render: estadoRenderer(vm), },
    { data: null, orderable: false, searchable: false, defaultContent: "" }
];

export default columns;